// extracted by mini-css-extract-plugin
export default {"btn":"LinkButton_btn__fY0wU"};